module.exports = __webpack_public_path__ + "img/zixueshe_prod.8d6ef613.png";